<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";

  button {
    display: flex;
    align-items: flex-start;
    gap: utils.in_rem(11px);
    flex-wrap: nowrap;
    border: none;
    outline: none;
    background-color: transparent;
    border-radius: 4px;

    :not(&[disabled]) {
      cursor: pointer;
      &:focus {
        outline: solid 2px colors.get("primary_50");
      }
    }

    .details {
      display: flex;
      flex-direction: column;
      gap: utils.in_rem(4px);

      h4 {
        @include colors.color(black_90);
        @include mixins.h4();
      }

      span {
        @include colors.color(black_50);
        @include mixins.body2();
      }
    }
  }
</style>

<script>
  import Avatar from "@sourcewhale/shared/svelte-design-system/components/atoms/Avatar.svelte";
  import { handleLeftClick } from "../../../../../../../assets/js/src/contact-panel";

  let { candidate, call, skeleton = false } = $props();

  const disabled = $derived(skeleton);
  const src = $derived(candidate?.photo);
  const name = $derived(candidate?.name || "Unknown Contact");
  const split = $derived(name.split(" "));
  const firstName = $derived(split[0]);
  const lastName = $derived(split.length > 1 ? split.at(-1) : "");

  const company = $derived(skeleton ? "Loading..." : candidate?.company);
  const number = $derived(call.kind === "inbound" ? call.from : call.to);
  const displayNumber = $derived(skeleton ? "Loading..." : number);

  const onclick = () => {
    if (!candidate.candidateId) return;
    handleLeftClick(undefined, "", "", {
      candidateId: candidate.candidateId,
    });
  };
</script>

<button {disabled} {onclick}>
  <Avatar size="medium" {skeleton} {src} {firstName} {lastName} />
  <div class="details">
    <h4 class:skeleton>{name}</h4>
    {#if company}
      <span class:skeleton>{company}</span>
    {/if}
    <span class:skeleton>{displayNumber}</span>
  </div>
</button>
